/* ABOUT US  */
export default function Styles(){
  return (
    <style>
      {`
.bg-black{
  background-color: #161616 !important;
}
.clrblack{
  color: #4e4646 ;
}
.about_us {

  background-image: linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.44) 100%),
    url(/static/images/landingPages/testimonalbg1.png);
  background-size: cover;
  background-repeat: no-repeat;

} 
.about_us_bg_dynamic {


  background-size: cover;
  background-repeat: no-repeat;

} 

@media (max-width: 768px) {
  .fs-48-60 {
    font-size: 32px;
    line-height: 40px;
  }
  .font-whatsapp{
    font-Size:16px;
  }
}

@media (min-width: 768px) {
  .fs-48-60 {
    font-size: 38px;
    line-height: 48px;
  }
  .font-whatsapp{
    font-Size:38px;
  }

}


@media (min-width:1024px) {

  .font-whatsapp{
    font-Size:38px;
  }

}


@media (min-width: 1280px) {
  .fs-48-60 {
    font-size: 44px;
    line-height: 55px;
  }
  .font-whatsapp{
    font-Size:44px;
  }

}
@media (max-width: 1534px) {
  .fs-22-24 {
    font-size: 22px;

  }

   .fs-16-18 {
     font-size: 16px;
    line-height: 20px;

   }
   .font-whatsapp{
    font-Size:44px;
  }
   
 }
@media (min-width: 1534px) {
  .fs-48-60 {
    font-size: 48px;
    line-height: 60px;
  }

  .fs-22-24 {
    font-size: 24px;
    
  }

  .fs-16-18 {
    font-size: 18px;
   line-height: 22px;
  }
  .font-whatsapp{
    font-Size:48px;
  }
 
}
`}
    </style>
  )
}



